import BigNumber from 'bignumber.js';

export const valueWithDecimals = (
  amount: string | BigNumber,
  decimals: number,
) => BigNumber(amount || 0).div(BigNumber(10).pow(decimals));
